import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { UserModule } from './components/user/user.module';
import { CompanyModule } from './components/company/company.module';
import { PhotographerModule } from './components/photographer/photographer.module';
import { AuthComponent } from './shared/components/auth/auth.component';
import { RedirectGuardService } from './shared/libs/auth/redirect-guard.service';
import { AuthGuardService } from './shared/libs/auth/auth-guard.service';
import { CompanyGuardService } from './shared/libs/auth/company-guard.service';

const routes: Routes = [
	{ path: '', redirectTo: 'user', pathMatch: 'full' },
	{
		path: 'auth',
		component: AuthComponent,
		canActivate: [AuthGuardService, RedirectGuardService]
	},
	{
		path: 'error',
		loadChildren: () => import('./shared/components/error/error.module').then((m) => m.ErrorModule)
	},
	{ path: 'user', loadChildren: () => import('./components/user/user.module').then((m) => m.UserModule) },
	{
		path: 'company',
		loadChildren: () => import('./components/company/company.module').then((m) => m.CompanyModule),
		canActivate: [AuthGuardService, RedirectGuardService]
	},
	{
		path: 'photographer',
		loadChildren: () => import('./components/photographer/photographer.module').then((m) => m.PhotographerModule),
		canActivate: [AuthGuardService, RedirectGuardService]
	},
	{
		path: 'share-media',
		loadChildren: () => import('./components/share-media/share-media.module').then((m) => m.ShareMediaModule),
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes), UserModule, CompanyModule, PhotographerModule],
	exports: [RouterModule]
})
export class AppRouting {}
